define.alias("shared/components/shared/ui/accordion-item", "settings/components/shared/ui/accordion-item");